import { Button } from '@/components/ui/button';
import { GOOGLE_REVIEW_URL } from '@/components/GoogleReviewButton';
import { Printer, Download, Star } from 'lucide-react';

const ReviewQRPage = () => {
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${encodeURIComponent(GOOGLE_REVIEW_URL)}&ecc=H&margin=10`;
  const qrCodeDownloadUrl = `https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&data=${encodeURIComponent(GOOGLE_REVIEW_URL)}&ecc=H&margin=10&download=1`;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-background py-12 px-6">
      {/* Print buttons - hidden when printing */}
      <div className="max-w-5xl mx-auto mb-8 flex justify-end gap-3 print:hidden">
        <Button onClick={handlePrint} className="btn-primary" data-testid="print-qr-btn">
          <Printer className="w-4 h-4 mr-2" />
          Print QR Code
        </Button>
        <a href={qrCodeDownloadUrl} download="amjed-tours-review-qr.png">
          <Button variant="outline" data-testid="download-qr-btn">
            <Download className="w-4 h-4 mr-2" />
            Download PNG
          </Button>
        </a>
      </div>

      {/* Printable Card */}
      <div className="max-w-2xl mx-auto bg-white rounded-3xl overflow-hidden shadow-2xl print:shadow-none print:rounded-none border-2 border-primary" data-testid="qr-card">
        {/* Header */}
        <div className="bg-primary text-white p-8 text-center">
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Cabinet Grotesk' }}>Amjed Tours</h1>
          <p className="text-lg opacity-90">Premium Car Rental in Pakistan</p>
        </div>

        {/* Main Content */}
        <div className="p-10 text-center">
          <div className="inline-flex items-center gap-1 mb-4">
            {[1, 2, 3, 4, 5].map(i => (
              <Star key={i} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
            ))}
          </div>

          <h2 className="text-3xl font-bold mb-3" style={{ fontFamily: 'Cabinet Grotesk' }}>
            Enjoyed Your Ride?
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            Scan the QR code below to leave us a Google review
          </p>

          {/* QR Code */}
          <div className="bg-white border-4 border-primary rounded-2xl p-6 inline-block mb-8">
            <img
              src={qrCodeUrl}
              alt="Scan to leave Google Review"
              className="w-72 h-72 mx-auto"
              data-testid="qr-code-image"
            />
          </div>

          {/* Instructions */}
          <div className="grid grid-cols-3 gap-4 mb-8 text-sm">
            <div className="bg-muted rounded-lg p-4">
              <div className="w-10 h-10 bg-accent text-white rounded-full flex items-center justify-center font-bold mx-auto mb-2">1</div>
              <p className="font-semibold">Open Camera</p>
              <p className="text-xs text-muted-foreground mt-1">Point at QR code</p>
            </div>
            <div className="bg-muted rounded-lg p-4">
              <div className="w-10 h-10 bg-accent text-white rounded-full flex items-center justify-center font-bold mx-auto mb-2">2</div>
              <p className="font-semibold">Tap Link</p>
              <p className="text-xs text-muted-foreground mt-1">Opens Google</p>
            </div>
            <div className="bg-muted rounded-lg p-4">
              <div className="w-10 h-10 bg-accent text-white rounded-full flex items-center justify-center font-bold mx-auto mb-2">3</div>
              <p className="font-semibold">Rate & Review</p>
              <p className="text-xs text-muted-foreground mt-1">Takes 30 seconds</p>
            </div>
          </div>

          <p className="text-lg font-semibold text-primary mb-2">
            Your feedback helps us grow!
          </p>
          <p className="text-sm text-muted-foreground">
            📞 0311-9951299 | 🌐 amjedtours.com
          </p>
        </div>

        {/* Footer */}
        <div className="bg-muted p-4 text-center text-xs text-muted-foreground">
          Thank you for choosing Amjed Tours — your trusted travel partner in Pakistan
        </div>
      </div>

      {/* Instructions for owner */}
      <div className="max-w-2xl mx-auto mt-8 bg-accent/10 border border-accent/30 rounded-lg p-6 print:hidden">
        <h3 className="font-bold mb-2 flex items-center gap-2">
          <span>💡</span> How to use this card
        </h3>
        <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside">
          <li>Click <strong>Print QR Code</strong> and print on A4 paper (or laminated card)</li>
          <li>Place inside each rental car (on dashboard or seat back)</li>
          <li>Hand out to customers at pickup — most will scan and review!</li>
          <li>You can also download the PNG and share it on WhatsApp or Facebook</li>
        </ul>
      </div>

      {/* Print-only styles */}
      <style>{`
        @media print {
          @page {
            size: A4;
            margin: 15mm;
          }
          body {
            background: white !important;
          }
        }
      `}</style>
    </div>
  );
};

export default ReviewQRPage;
